import { useQuery } from '@apollo/client';

import { EVENT_OPTIONS } from '../graphql/query/eventOptionsQuery.graphql';

export const useEventOptionsQuery = () => {
  return useQuery(EVENT_OPTIONS);
};
